import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { ImageB2c, ImageType } from '../../../model/image.model';
import { GalleryService } from '../gallery.service';
import { Swiper } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

interface DialogData {
  galleryService: GalleryService,
  alternativeText?: string;
}

@Component({
  selector: 'raf-image-dialog',
  templateUrl: './image-dialog.component.html',
  styleUrls: ['./image-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageDialogComponent implements OnInit {
  image$: BehaviorSubject<ImageB2c | undefined>;
  images$: BehaviorSubject<ImageB2c[]>;
  initialSlide?: number;
  galleryService: GalleryService;
  alternativeText?: string;
  threeSixtyActive = false;
  activeThreeSixtyImg?: ImageB2c;
  ImageType = ImageType;

  @ViewChild(SwiperComponent, {static: false})
  swiperComponent?: SwiperComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    public dialogRef: MatDialogRef<ImageDialogComponent>
  ) {
    this.galleryService = data.galleryService;
    this.alternativeText = data.alternativeText;
    this.image$ = this.galleryService.image$;
    this.images$ = this.galleryService.thumbnails$;
  }

  ngOnInit() {
    if (this.image$?.value && this.image$?.value) {
      this.initialSlide = this.images$?.value.indexOf(this.image$.value);
    }
  }

  close(): void {
    this.closeThreeSixty();
    this.dialogRef.close();
  }

  next(): void {
    this.galleryService.next();
  }

  previous(): void {
    this.galleryService.previous();
  }

  selectImage(image: ImageB2c): void {
    this.galleryService.selectImage(image);
  }

  onSlideChange($event: [swiper: Swiper]) {
    const previousImageIdx = $event[0].previousIndex;
    const previousImage = this.images$.value[previousImageIdx];
    if (previousImage.type === ImageType.THREE_SIXTY) {
      this.closeThreeSixty();
    }

    const activeImageIdx = $event[0].activeIndex;
    const activeImage = this.images$.value[activeImageIdx];
    this.galleryService.selectImage(activeImage);
  }

  openThreeSixty(image: ImageB2c) {
    this.threeSixtyActive = true;
    this.activeThreeSixtyImg = image;
  }

  closeThreeSixty() {
    this.threeSixtyActive = false;
  }
}
